import { SelectLayout } from "../interfaces";

var shouldUseNativeSelect = function shouldUseNativeSelect(layout, matches, _ref) {
  var _ref$isMulti = _ref.isMulti,
      isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === void 0 ? false : _ref$isSearchable,
      _ref$isExperimentalLa = _ref.isExperimentalLayout,
      isExperimentalLayout = _ref$isExperimentalLa === void 0 ? false : _ref$isExperimentalLa;

  if (layout === SelectLayout.Native) {
    return true;
  }

  if (layout === SelectLayout.Custom) {
    return false;
  } // SelectLayout.Default case


  if (isMulti || isSearchable || isExperimentalLayout) {
    return false;
  }

  if (matches.s) {
    return true;
  }

  return false;
};

export default shouldUseNativeSelect;